import { ProcessMenu } from './menu-processing'
const menu = [
  [
    {
      title: 'Customer',
      id: 'Customer-14',
      type: 'group',
      children: [
        {
          title: 'Customer',
          id: 'Customer-16',
          type: 'collapse',
          claim: 'CustomerAdministrator',
          children: [
            {
              title: 'Administrator',
              id: 'Administrator-15',
              paths: ['/'],
              hidden: false,
              targetView: 'CustomerAdministrator',
              type: 'item',
            },
          ],
          script:
            '(function checkAuthorization() : any {\n    if(isLoggedIn && claims && (!claims?.player && !claims?.customerAdministrator)) {\n        navigate(`/${(Views.Home)}`, { replace: true });\n    }\n})();',
        },
      ],
    },
  ],
]
export default ProcessMenu(menu)
